module.exports = __webpack_public_path__ + "static/media/filter.d4aabd40.svg";